import React, { useEffect } from "react";

import { bool, func, shape, string } from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";
import { goBack } from "react-router-redux";
import { actions as layoutActions } from "reducers/layout";

import Head from "pages/_components/Head";
import { resizableRoute } from "pages/_components/Resizable";
import { dispatchV3ShellLayout, isUxDashboardImprovementsEnabled } from "util/v3ShellLayoutSync";

import { actions as tokenActions, selectors as tokenSelectors } from "reducers/token";
import * as i18n from "util/i18n";

import { Box, Button, Text, Switch } from "@ui-kit/components/index.es";
import Notification from "pages/_components/Notification";

function ActivateTokenWithBiometrics(props) {
    ActivateTokenWithBiometrics.propTypes = {
        dispatch: func.isRequired,
        inviteCode: string.isRequired,
        tokenBiometricValid: bool.isRequired,
        fetchingToken: bool.isRequired,
        isDesktop: bool.isRequired,
        embeddedInV3Shell: bool,
        match: shape({
            params: shape({ idForm: string }),
        }).isRequired,
    };

    ActivateTokenWithBiometrics.defaultProps = {
        embeddedInV3Shell: false,
    };

    const { dispatch, inviteCode, tokenBiometricValid, fetchingToken, isDesktop, embeddedInV3Shell } = props;

    useEffect(() => {
        dispatch(tokenActions.setTokenBiometricValid(false));
    }, []);

    useEffect(() => {
        if (!embeddedInV3Shell || !isUxDashboardImprovementsEnabled()) {
            return undefined;
        }
        dispatchV3ShellLayout(dispatch, {
            titleKey: "settings.tokenPassword",
            goBackPath: "/settings/token",
            rightContentMobile: null,
            scopes: ["activateTokenBiometric"],
        });
        return () => {
            dispatch(layoutActions.setScopes([]));
            dispatch(layoutActions.setTitleKey(""));
            dispatch(layoutActions.setHeaderTitle(""));
            dispatch(layoutActions.setHeaderSubtitle(""));
            dispatch(layoutActions.setGoBackPath(null));
            dispatch(layoutActions.setRightContentMobile(null));
        };
    }, [dispatch, embeddedInV3Shell]);

    const handleBack = () => dispatch(goBack());

    const handleOnChange = () => {
        if (tokenBiometricValid) {
            dispatch(tokenActions.setTokenBiometricValid(false));
        } else {
            dispatch(tokenActions.tokenBiometricValidationRequest());
        }
    };

    const handleSubmit = () => {
        const { match } = props;
        const isSync = match.path === "/settings/token/synchronization/biometricActivation";
        if (isSync) {
            dispatch(tokenActions.tokenSyncNewDeviceRequest());
        } else {
            dispatch(tokenActions.tokenBiometricActivationRequest(inviteCode));
        }
    };

    const isShellActive = embeddedInV3Shell && isUxDashboardImprovementsEnabled();

    return (
        <>
            {!isShellActive && <Notification scopeToShow="activateTokenBiometric" />}
            <Box mx={24} column align="center" className="admin-detail-head z-index-1 px-0">
                {(isDesktop || !isShellActive) && (
                    <Head
                        onBack={handleBack}
                        headerClassName="blue-main-header-mobile"
                        centerElement={() => (
                            <Text as="subtitle" className="m-0 no-wrap text-white font-medium">
                                {i18n.get("settings.tokenPassword")}
                            </Text>
                        )}
                        accessibilityTextId="settings.tokenPassword"
                    />
                )}
                <Text align="center" variant="subtitle">
                    {i18n.get("setting.token.device.security.title")}
                </Text>
                <Text align="center" variant="body2">
                    {i18n.get("setting.token.device.security.info")}
                </Text>
                <Box w="100%" my="40">
                    <Switch
                        id="Switch"
                        label={i18n.get("setting.token.device.security")}
                        name="SwitchName"
                        onChange={() => {
                            handleOnChange();
                        }}
                        isChecked={tokenBiometricValid}
                    />
                </Box>

                <Button
                    className="w-100"
                    icon="ArrowRight"
                    iconVariant="outline"
                    size="large"
                    text={i18n.get("setting.token.device.security.continue")}
                    isInactive={!tokenBiometricValid || fetchingToken}
                    onClick={() => {
                        handleSubmit();
                    }}
                />
            </Box>
        </>
    );
}

const mapStateToProps = (state) => ({
    inviteCode: tokenSelectors.getInviteCode(state),
    tokenBiometricValid: tokenSelectors.getTokenBiometricValid(state),
    fetchingToken: tokenSelectors.getFetchingToken(state),
});

export default compose(connect(mapStateToProps), resizableRoute)(ActivateTokenWithBiometrics);
